module.exports = {
  translations: {
    // metamask
    'metamask.pleaseInstallFirst': 'Please install MetaMask first!',
    'metamask.youNeedSignMessage': 'You need to sign the message to be able to use system!',
    // award
    'award.pleaseSignIn': 'Đăng nhập vào tài khoản Twitter của bạn để nhận quà.',
    'award.signInTwitter': 'Đăng nhập bằng Twitter',
    'award.congratulation': 'Chúc mừng bạn!',
    'award.openLinkBelow': 'Bạn hãy nhấn vào URL bên dưới và nhận Pantodraw. ',
    'award.gotoTheLottery': 'Từ ứng dụng chuyên dụng hãy đi tới chỗ rút thăm và rút thăm để trúng sản phẩm mà bạn yêu thích.',
    'award.termOf': 'Điều khoản follow Twitter và Retweet Campaign',
    'award.sorry': 'Rất tiếc!',
    'award.campaignHasEnded': 'Bạn chưa thoả điều kiện hoặc Campaign này đã kết thúc.'
  }
}